






















import Vue from 'vue';
import UpperBar from '@/components/UpperBar/index.vue';
import SideBar from '@/components/SideBar/index.vue';
import { MenuItem } from '@/store/types';

export default Vue.extend({
  name: 'App',
  components: {
    UpperBar,
    SideBar
  },
  data: () => ({
    drawer: false
  }),
  computed: {
    menuItems(): MenuItem[] {
      return (this as any).$store.state.menuItems;
    }
  },
  methods: {
    toggleLeftMenu(): void {
      console.log();
    },
    toggleRightMenu(): void {
      this.drawer = !this.drawer;
    }
  }
});
